export const phoneRegExp = /[\d{3} \d{3} \d{3}]/

export const peselRegExp = /[\d{11}]/

export const postalCodeRegExp = /[\d{2}-\d{3}]/
